import React, { ChangeEvent, useEffect, useState } from "react";
import { Formik } from "formik";
import { Button, Form, Text, StandaloneFormPage } from "tabler-react";
import logo from "../../assets/img/logo.svg";

import { useHistory } from "react-router-dom";
import { validatePassword } from "../../utils/validatePassword";
import { Alerta } from "../../utils/Alerta";
import { useAuth } from "../../hooks/AuthContext";

export default function ResetPassword() {
  const history = useHistory();
  const [passwordError, setPasswordErr] = useState<string[]>([]);
  const [disableButton , setDisableButton] = useState(true);
  const [newPassword, setNewPassword] = useState<string>("")
  const [confirmNewPassword, setConfirmNewPassword] = useState<string>(" ")
  const [code, setCode] = useState<string>()

  const { email, sendNewPassword, store } = useAuth()

  useEffect(() => {
      if (passwordError.length === 0 && !!code && !!newPassword) { setDisableButton(false) };
  }, [passwordError, code, newPassword]);

  async function handleSubmitChangePassword(email?: string){
    try {
      const data = {
        email: email ,
        newPassword: newPassword,
        verificationCode: code
      }

      await sendNewPassword(data);

      if (store?.resetPasswordByTime) {
        store.resetPasswordByTime = false;
      }

      if (store?.resetPasswordByInactive) {
        store.resetPasswordByInactive = false;
      }

      if (store?.newPasswordRequired) {
        store.newPasswordRequired = false;
      }

      Alerta('Senha alterada com sucesso!', "success");

      history.push('/');
    } catch (err) {
      console.error(err)
      Alerta('Erro ao alterar sua senha!');
    }
  }

  const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newPasswordValue = event.currentTarget.value;
    setNewPassword(newPasswordValue);
    setPasswordErr(validatePassword(newPasswordValue, confirmNewPassword));
  };

  const handleConfirmPasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    const confirmNewPasswordValue = event.currentTarget.value;
    setConfirmNewPassword(confirmNewPasswordValue);
    setPasswordErr(validatePassword(newPassword, confirmNewPasswordValue));
  };

  const formattedPasswordErrors = passwordError.map((message, index) => (
    <Text key={index} color={"red"}>{message}</Text>
  ));

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      validate={values => {
        // same as above, but feel free to move this into a class method now.
        let errors: any = {};
        if (!values.email) {
          errors.email = "Obrigatório";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
          errors.email = "Endereço de e-mail inválido";
        }
        return errors;
      }}
      onSubmit={async (
        values,
        { setSubmitting, setErrors /* setValues and other goodies */ }
      ) => {
        await handleSubmitChangePassword(values.email);
      }}
      render={() => (
        <StandaloneFormPage
          imageURL={logo}
          children={
            <Form>
              <Form.Group label="Código" className="form-reset">
                <Form.Input
                  placeholder="Código recebido por email"
                  name="code"
                  onChange={(event: ChangeEvent<HTMLInputElement>) => setCode(event.target.value)}
                  error={''}
                />
              </Form.Group>
              <Form.Group label="Nova Senha" className="form-reset">
                <Form.Input
                  placeholder="Digite sua nova senha"
                  name="password"
                  onChange={handlePasswordChange}
                  error={passwordError.length > 0 ? " " : ""}
                  type="password"
                />
              </Form.Group>
                <Form.Group label="Digite a nova senha novamente" className="form-reset">
                  <Form.Input
                    placeholder="Digite sua nova senha novamente"
                    onChange={handleConfirmPasswordChange}
                    name="confirmPassword"
                    error={passwordError.length > 0 ? " " : ""}
                    type="password"
                  />
              </Form.Group>
              {formattedPasswordErrors}
              <Button
                size="sm"
                href="#"
                RootComponent="a"
                color="primary"
                onClick={() => handleSubmitChangePassword(email)}
                className="button-store"
                disabled={disableButton}
              >
                Alterar Senha
              </Button>
            </Form>
          }
        />
      )}
    />
  );
}
